import { ref, get } from 'firebase/database';
import { db } from './firebaseConfig';

function escapeCsvValue(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
}

function toCsv(headers, rows) {
  const headerLine = headers.map(escapeCsvValue).join(',');
  const dataLines = rows.map(row => row.map(escapeCsvValue).join(','));
  return [headerLine, ...dataLines].join('\n');
}

function downloadCsv(filename, csvContent) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function getCutoffTimestamp(rangeOption) {
  const now = Date.now();
  if (rangeOption === '30days') return now - 30 * 24 * 60 * 60 * 1000;
  if (rangeOption === '3months') return now - 90 * 24 * 60 * 60 * 1000;
  return 0;
}

function parseTimestamp(value) {
  if (!value) return 0;
  if (typeof value === 'number') return value;
  const parsed = new Date(value).getTime();
  return isNaN(parsed) ? 0 : parsed;
}

export async function exportUsersCsv(rangeOption) {
  const snapshot = await get(ref(db, 'users/'));
  const data = snapshot.val();
  if (!data) throw new Error('No user data found.');
  const cutoff = getCutoffTimestamp(rangeOption);
  const headers = ['Name', 'Phone', 'Email', 'City', 'Rating', 'Trips', 'Gender', 'Vehicle', 'Created At', 'Docs Verified'];
  const rows = Object.values(data)
    .filter(u => parseTimestamp(u.createdAt) >= cutoff)
    .map(u => [u.name || '', u.phone || '', u.email || '', u.city || '', u.rating || 0, u.trips || 0, u.gender || '', u.vehicle || '', u.createdAt || '', u.docsVerified ? 'Yes' : 'No']);
  downloadCsv('guningo_users.csv', toCsv(headers, rows));
}

export async function exportRidesCsv(rangeOption) {
  const snapshot = await get(ref(db, 'rides/'));
  const data = snapshot.val();
  if (!data) throw new Error('No ride data found.');
  const cutoff = getCutoffTimestamp(rangeOption);
  const headers = ['Driver', 'Driver Phone', 'From', 'To', 'Date', 'Time', 'Reach Time', 'Seats', 'Price', 'Vehicle', 'Status', 'Posted At'];
  const rows = Object.values(data)
    .filter(r => parseTimestamp(r.postedAt) >= cutoff)
    .map(r => [r.driver || '', r.driverPhone || '', r.from || '', r.to || '', r.date || '', r.time || '', r.reachTime || '', r.seats || 0, r.price || 0, r.vehicle || '', r.status || '', r.postedAt || '']);
  downloadCsv('guningo_rides.csv', toCsv(headers, rows));
}

export async function exportBookingsCsv(rangeOption) {
  const snapshot = await get(ref(db, 'bookingRequests/'));
  const data = snapshot.val();
  if (!data) throw new Error('No booking data found.');
  const cutoff = getCutoffTimestamp(rangeOption);
  const headers = ['Passenger Name', 'Passenger Phone', 'Driver', 'Driver Phone', 'From', 'To', 'Date', 'Seats', 'Total Amount', 'Status', 'Requested At'];
  const rows = Object.values(data)
    .filter(b => parseTimestamp(b.requestedAt) >= cutoff)
    .map(b => [b.passengerName || '', b.passengerPhone || '', b.driver || '', b.driverPhone || '', b.from || '', b.to || '', b.date || '', b.seats || 0, b.totalAmount || 0, b.status || '', b.requestedAt || '']);
  downloadCsv('guningo_bookings.csv', toCsv(headers, rows));
}

export async function exportPaymentsCsv(rangeOption) {
  const snapshot = await get(ref(db, 'payments/'));
  const data = snapshot.val();
  if (!data) throw new Error('No payment data found.');
  const cutoff = getCutoffTimestamp(rangeOption);
  const headers = ['Passenger Name', 'Passenger Phone', 'Driver', 'From', 'To', 'Date', 'Amount', 'Method', 'Status', 'Timestamp'];
  const rows = Object.values(data)
    .filter(p => parseTimestamp(p.timestamp) >= cutoff)
    .map(p => [p.passengerName || '', p.passengerPhone || '', p.driver || '', p.from || '', p.to || '', p.date || '', p.amount || 0, p.method || '', p.status || '', p.timestamp || '']);
  downloadCsv('guningo_payments.csv', toCsv(headers, rows));
}